import { render, staticRenderFns } from "./ProjectQuestionEditor.vue?vue&type=template&id=5c0d79d4&scoped=true&"
import script from "./ProjectQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuestionEditor.vue?vue&type=style&index=0&id=5c0d79d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d79d4",
  null
  
)

export default component.exports